/** @deprecated $current_url is autologged by posthog-js */
export const $CURRENT_URL = "$current_url";

/** @deprecated Just camelcase your attributes. Don't fight AI autocomplete ;) */
export const $PROJECT_ID_LEGACY = "$project_id";

/** @deprecated Just camelcase your attributes. Don't fight AI autocomplete ;) */
export const $PROJECT_OWNER_ID_LEGACY = "$projectOwnerId";

/** @deprecated Just camelcase your attributes. Don't fight AI autocomplete ;) */
export const $IS_OWNER_OF_PROJECT_LEGACY = "$isOwnerOfProject";

/** @deprecated Just camelcase your attributes. Don't fight AI autocomplete ;) */
export const $SITE_ID_LEGACY = "$site_id";
